import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06b7a9af"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "row justify-content-center pt-5 gx-5",
  ref: "sectionMain",
  id: "section-3"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-12 col-md-12 col-sm-12 d-flex justify-content-between" }, [
  /*#__PURE__*/_createElementVNode("header", { class: "col-lg-12 col-md-12 col-sm-12 d-lg-flex d-md-flex justify-content-between" }, [
    /*#__PURE__*/_createElementVNode("h5", null, "Potencial construtivo")
  ])
], -1))
const _hoisted_3 = { class: "row section-content d-lg-flex d-md-block justify-content-around" }
const _hoisted_4 = { class: "col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 d-flex flex-column first" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 second" }
const _hoisted_7 = { class: "col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 second" }
const _hoisted_8 = { class: "col-lg-12 section-content" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Principais indicações", -1))
const _hoisted_10 = { class: "main-referral" }
const _hoisted_11 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_responsive_table = _resolveComponent("responsive-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("img", {
          class: _normalizeClass(["section-map", { 'blurred': _ctx.isBlockedOpportunity }]),
          id: "mapImage",
          src: _ctx.completeOpportunity.thumb_pot,
          alt: "map",
          onLoad: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.adjustTableHeight && _ctx.adjustTableHeight(...args)))
        }, null, 42, _hoisted_5)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_responsive_table, {
          tableTitle: _ctx.constructivePotencialTable.title,
          tableHeaders: _ctx.constructivePotencialTable.headers,
          tableData: _ctx.constructivePotencialTable.data,
          pointColor: _ctx.constructivePotencialTable.circleColor,
          isBlockedOpportunity: _ctx.isBlockedOpportunity,
          taxHeight: _ctx.tableResizableHeight
        }, null, 8, ["tableTitle", "tableHeaders", "tableData", "pointColor", "isBlockedOpportunity", "taxHeight"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_responsive_table, {
          tableTitle: _ctx.areaChartTable.title,
          tableHeaders: _ctx.areaChartTable.headers,
          tableData: _ctx.areaChartTable.data,
          pointColor: _ctx.areaChartTable.circleColor,
          isBlockedOpportunity: _ctx.isBlockedOpportunity,
          taxHeight: _ctx.tableResizableHeight
        }, null, 8, ["tableTitle", "tableHeaders", "tableData", "pointColor", "isBlockedOpportunity", "taxHeight"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(), _createBlock(_component_responsive_table, {
            key: _ctx.index,
            tableTitle: _ctx.computableAreaTable.title,
            tableHeaders: _ctx.computableAreaTable.headers,
            tableData: _ctx.computableAreaTable.data,
            pointColor: _ctx.computableAreaTable.circleColor,
            isBlockedOpportunity: _ctx.isBlockedOpportunity,
            dontWrap: true
          }, null, 8, ["tableTitle", "tableHeaders", "tableData", "pointColor", "isBlockedOpportunity"])),
          (_openBlock(), _createBlock(_component_responsive_table, {
            key: _ctx.index,
            tableTitle: _ctx.reachedCaTable.title,
            tableHeaders: _ctx.reachedCaTable.headers,
            tableData: _ctx.reachedCaTable.data,
            pointColor: _ctx.reachedCaTable.circleColor,
            isBlockedOpportunity: _ctx.isBlockedOpportunity,
            dontWrap: true
          }, null, 8, ["tableTitle", "tableHeaders", "tableData", "pointColor", "isBlockedOpportunity"])),
          (_openBlock(), _createBlock(_component_responsive_table, {
            key: _ctx.index,
            tableTitle: _ctx.totalBuiltAreaTable.title,
            tableHeaders: _ctx.totalBuiltAreaTable.headers,
            tableData: _ctx.totalBuiltAreaTable.data,
            pointColor: _ctx.totalBuiltAreaTable.circleColor,
            isBlockedOpportunity: _ctx.isBlockedOpportunity,
            dontWrap: true
          }, null, 8, ["tableTitle", "tableHeaders", "tableData", "pointColor", "isBlockedOpportunity"])),
          (_openBlock(), _createBlock(_component_responsive_table, {
            key: _ctx.index,
            tableTitle: _ctx.circulationDiscountTable.title,
            tableHeaders: _ctx.circulationDiscountTable.headers,
            tableData: _ctx.circulationDiscountTable.data,
            pointColor: _ctx.circulationDiscountTable.circleColor,
            isBlockedOpportunity: _ctx.isBlockedOpportunity,
            dontWrap: true
          }, null, 8, ["tableTitle", "tableHeaders", "tableData", "pointColor", "isBlockedOpportunity"])),
          (_openBlock(), _createBlock(_component_responsive_table, {
            key: _ctx.index,
            tableTitle: _ctx.privateAreaTable.title,
            tableHeaders: _ctx.privateAreaTable.headers,
            tableData: _ctx.privateAreaTable.data,
            pointColor: _ctx.privateAreaTable.circleColor,
            isBlockedOpportunity: _ctx.isBlockedOpportunity,
            dontWrap: true
          }, null, 8, ["tableTitle", "tableHeaders", "tableData", "pointColor", "isBlockedOpportunity"])),
          (_openBlock(), _createBlock(_component_responsive_table, {
            key: _ctx.index,
            tableTitle: _ctx.eficiencyTable.title,
            tableHeaders: _ctx.eficiencyTable.headers,
            tableData: _ctx.eficiencyTable.data,
            pointColor: _ctx.eficiencyTable.circleColor,
            isBlockedOpportunity: _ctx.isBlockedOpportunity,
            dontWrap: true
          }, null, 8, ["tableTitle", "tableHeaders", "tableData", "pointColor", "isBlockedOpportunity"]))
        ])
      ])
    ]),
    (_ctx.showHr)
      ? (_openBlock(), _createElementBlock("hr", _hoisted_11))
      : _createCommentVNode("", true)
  ], 512))
}